import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { TCreateGift } from './types'
import { getGiftsCategories } from '../../giftsCategories/list/model'
import { buildDisplayRequirements } from '../utils'

export const setGift = createEvent<TCreateGift>()
export const submitCreateGift = createEvent<TCreateGift>()
export const $gift = restore(setGift, {
  id: 0,
  name: '',
  title: '',
  description: '',
  imageSmall: '',
  imageMedium: '',
  imageLarge: '',
  categoryId: 0,
  price: 0,
  costPrice: 0,
  availableNumber: 0,
  availableCountries: [],
  isShow: false,
  giftType: 'GIFT_TYPE_NON_MATERIAL',
  label: '',
  downloadUrl: '',
  sorting: 0,
  conversion: {
    target_amount: 0,
    min_crowns_amount: 0,
  },
  bonusReview: {
    platform_name: '',
    platform_title: '',
    platform_link: '',
  },
  versionMinIos: '',
  versionMinAndroid: '',
})

export const giftCategoriesList = createEvent()

export const createGift = fx<TCreateGift, void>({
  method: 'POST',
  url: '/giftshop/gift',
})

sample({
  //@ts-ignore
  clock: submitCreateGift,
  fn: (gift) => {
    const { versionMinIos, versionMinAndroid, ...giftFields } = gift
    const displayRequirements = buildDisplayRequirements(
      versionMinIos,
      versionMinAndroid,
    )

    return {
      url: `/giftshop/gift`,
      formData: {
        ...giftFields,
        giftCategory: gift.categoryId,
        conversion: JSON.stringify(gift.conversion),
        bonusReview: gift.bonusReview ? JSON.stringify(gift.bonusReview) : null,
        ...(displayRequirements ? { displayRequirements } : {}),
      },
    }
  },
  target: createGift,
})

sample({
  // @ts-ignore
  clock: giftCategoriesList,
  target: getGiftsCategories,
})
